<template>
  <section class="container" id="headers-list">
    <router-link to="/imports/templates">
      <LeftOutlined lass="icon--back" />
      <span>Volver</span>
    </router-link>

    <h2 class="container__title">Editar plantilla de {{ templateName }}</h2>
    <p class="container__subtitle">
      Selecciona las cabeceras que deseas usar en tu plantilla y personalízalas para cargar datos.
    </p>

    <a-row type="flex" justify="space-between">
      <a-col>
        <AddHeadersModal :type="type" :headers="headers" />
      </a-col>
    </a-row>
    <div class="container__body">
      <HeadersList :templateName="templateName" :type="type" />
    </div>
    <div class="container__footer">
      <a-row type="flex" justify="end">
        <a-col>
          <a-space>
            <a-button @click="handleCancel">Cancelar</a-button>
            <a-tooltip>
              <template #title v-if="disabledSave">
                {{ 
                  !disabledHubspotRequired ? 'No hay nuevos cambios por guardar.' :
                  'Para guardar, se requiere que todas las columnas marcadas como Dato requerido estén homologadas con HubSpot, ya que la importación está activada'
                }}
              </template>
              <a-button
                type="primary"
                id="save-import-template"
                :loading="loading"
                :disabled="disabledSave"
                @click="validationDeleteItem"
              >
                Guardar plantilla
              </a-button>
            </a-tooltip>
          </a-space>
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script>
import HeadersList from "@/app/imports/components/lists/HeadersList.vue";
import AddHeadersModal from "@/app/imports/components/modals/modalTemplates/AddHeadersModal.vue";
import { LeftOutlined, QuestionCircleOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { defineComponent, createVNode } from "vue";
import { message, Modal } from "ant-design-vue";
import EventBus from "@/app/shared/utils/eventBus";
import { cloneDeep, isEqual } from "lodash";
import { StatusHubpspot } from "@/@types/integrations";
import { HubspotIntegrationType } from "@/app/integrations/utils/enums";

export default defineComponent({
  components: {
    HeadersList,
    AddHeadersModal,
    LeftOutlined,
    ExclamationCircleOutlined,
  },
  props: {
    type: {
      required: true,
      type: String,
      validator: (value) => ["client", "product"].includes(value),
    },
  },
  data() {
    return {
      loading: false,
      nameDeleteList: [],
      selectedDelete: [],
      checkedList: [],
      allItem: [],
      initialActiveFields: [],
      disabledHubspotRequired: false,
    };
  },
  computed: {
    headers() {
      if (this.type == "client") {
        return this.$store.getters["getTemplateClientHeaders"];
      } else return this.$store.getters["getTemplateProductHeaders"];
    },
    templateName() {
      return this.type == "client" ? "contactos" : "productos";
    },
    actives() {
      return this.$store.getters["getActiveTemplateFields"];
    },
    checkList() {
      return this.actives?.filter((item) => item.show_on_workspace != true);
    },
    nameList() {
      return this.actives
        ?.filter((item) => item.show_on_workspace != true && item.name != "code_client")
        .map((item) => item.name);
    },
    templates() {
      return this.$store.getters["getTemplatesFromPortfolio"];
    },
    subtraction() {
      return this.templates?.client_template?.length - this.actives?.length;
    },
    hasHubspotIntegration() {
      return this.$store.getters["getDataUser"]?.customer?.hubspot_status == StatusHubpspot.Integrated;
    },
    hasHubspotImportContacts() {
      const functionality = this.$store.getters.getHubspotByCode(HubspotIntegrationType.Import);
      if (functionality) return true;
      return false;
    },
    hasPendingTemplateFieldOptions() {
      return this.$store.getters["hasPendingTemplateFieldOptions"];
    },
    disabledSave() {
      const hasChanges =
        !isEqual(this.initialActiveFields, this.actives) || this.hasPendingTemplateFieldOptions;

      if (this.type == 'client' && this.hasHubspotIntegration && this.hasHubspotImportContacts)
        return !hasChanges || this.disabledHubspotRequired;

      return !hasChanges;
    },
    activesList() {
      return this.$store.getters["getActiveTemplateFieldsOrdered"];
    },
  },
  watch: {
    activesList(newVal) {
      console.log("activesList: ", newVal)
      const find = newVal.findIndex((el) => {
        console.log("activesList property: ", !el.hubspot_property)
        return el.is_required && !el.hubspot_property && el.name != 'code_client'
      });
      console.log(find, 'find item activesList')
      this.disabledHubspotRequired = find >= 0;
    }
  },
  async created() {
    await this.$store.dispatch("replacePendingTemplateFieldOptions", {});

    if (!this.$store.getters["getTemplateSelectedPortfolio"]) {
      this.$router.push("/imports/templates");
      return;
    }
    EventBus.on("NAME_DELETE_ITEM_TEMPLATE", (item) => {
      this.nameDeleteList.push(item);
      this.nameItemList();
    });
    EventBus.on("NAME_UNCHECK_ITEM_TEMPLATE", (item) => {
      this.checkedList.push(item);
      this.nameItemList();
    });

    await this.$store.dispatch("setActiveFieldsTemplateByType", this.type);
    this.initialActiveFields = cloneDeep(this.$store.getters["getActiveTemplateFields"]);
  },
  methods: {
    validationDeleteItem() {
      console.log(this.allItem, 'this.allItem');
      if (this.subtraction >= 0) {
        if ((this.subtraction === 1 || this.checkList?.length === 2) && this.allItem.length > 0) {
          this.handleConfirmationDeleteItemOnlyOne();
        } else if ((this.subtraction >= 2 || this.checkList?.length >= 3) && this.allItem.length > 0) {
          this.handleConfirmationDeleteItemGreaterThanTwo();
        } else {
          this.handleSave();
        }
      } else {
        this.handleSave();
      }
    },
    async handleSave() {
      try {
        this.loading = true;
        await this.$store.dispatch("saveTemplateByType", this.type);
        if (this.hasPendingTemplateFieldOptions) {
          await this.$store.dispatch("saveTemplateFieldOptions");
        }
        this.$router.push("/imports/templates");
        message.success("Cambios guardados con éxito.");
      } catch {
        message.error("No se pudieron guardar los cambios de la plantilla.");
      } finally {
        this.loading = false;
      }
    },
    handleConfirmationDeleteItemOnlyOne() {
      if (this.type === "client") {
        Modal.confirm({
          title: "¿Estás seguro de quitar un campo preestablecido de tu plantilla?",
          content: `Recuerda que el campo "${this.allItem}" , es solicitado al crear un nuevo contacto. Si lo quitas, ya no podrás visualizar este dato en la información de tus contactos.`,
          icon: createVNode(QuestionCircleOutlined),
          onOk: () => this.handleSave(),
          centered: true,
          okText: "Guardar cambios",
          cancelText: "Cancelar",
        });
      } else {
        this.handleSave();
      }
    },
    handleConfirmationDeleteItemGreaterThanTwo() {
      if (this.type === "client") {
        Modal.confirm({
          title: "Estas quitando campos importantes, ¿Estás seguro de guardar estos cambios?",
          content: `Recuerda los campos "${this.allItem}", son solicitados al crear un nuevo contacto. Si los quitas, ya no podrás visualizar estos datos en la información de tus contactos.`,
          icon: createVNode(QuestionCircleOutlined),
          onOk: () => this.handleSave(),
          centered: true,
          okText: "Guardar cambios",
          cancelText: "Cancelar",
        });
      } else {
        this.handleSave();
      }
    },
    nameItemList() {
      const a = this.checkedList;
      const b = this.nameDeleteList;
      let c = [];
      let d = [];
      const uniqueGroup = [];

      a.forEach((item) => {
        c = item.name;
      });

      b.forEach((item) => {
        d = item.name;
      });

      if (c.length > 0) {
        this.selectedDelete.push(c);
      } else if (d.length > 0) {
        this.selectedDelete.push(d);
      }
      this.selectedDelete.forEach((listName) => {
        const elementAdded = uniqueGroup.find((u) => u === listName);
        if (!elementAdded) {
          uniqueGroup.push(listName);
        }
      });
      return (this.allItem = uniqueGroup);
    },
    handleCancel() {
      Modal.confirm({
        title: "¿Deseas descartar los cambios realizados?",
        content: "Recuerda que si no guardas los cambios que realizaste, estos serán descartados.",
        okText: "Sí, descartar",
        cancelText: "No, seguir editando",
        icon: createVNode(ExclamationCircleOutlined),
        centered: true,
        onOk: () => {
          this.$router.push('/imports/templates');
        },
      });
    },
  },
  beforeUnmount() {
    this.$store.dispatch("replacePendingTemplateFieldOptions", {});
  },
});
</script>

<style lang="sass" scoped>
.container
  min-width: 700px
  // max-width: calc( 50% + 20px )
  max-width: 1454px
  height: calc(100vh - #{$header-height} - 26px - 40px)
  max-height: calc(100vh - #{$header-height} - 26px - 40px)
  padding: 20px 20px 0 20px
  display: flex
  flex-direction: column

  &__title
    margin: 12px 0 4px 0

  &__subtitle
    padding-bottom: 12px
    border-bottom: $border-normal

  &__body
    flex: auto
    margin-top: 8px

  &__footer
    padding: 12px 20px
    border-top: $border-normal

.icon--back
  margin-right: 8px

.button--link
  margin-right: 4px

.headers-list
  display: flex
  flex-direction: column
  flex: 1 1 auto
</style>
